import $http from '@/model/utils/http'

// 获取设备类型
const getDeviceType = () => $http.get('/org/eq/getAllEqType')
// 获取该机构的设备列表
const getDeviceList = (params) => $http.get('/org/eq/getEqList', {
    params
})

// 机构添加设备
const addDevice = (eq_id) => $http.post('/org/eq/addEq',eq_id)
// 机构设备对应用户列表
const deviceBindUsers = (params) => $http.get('/org/eq/eqUserList', {
    params
})
// 用户绑定设备
const userBindDevice = (params) => $http.post('/org/eq/addEqUser', params)
// 用户解绑设备
const userUnbindDevice = (params) => $http.put('/org/eq/removeUser', params)
// 设备绑定记录
const deviceBindLog = (params) => $http.get('/org/eq/bindEqLog', {
    params
})


// 获取设备类型
const deviceType = () => $http.get('/org/Category/getEqType')
// 获取设备品牌
const deviceBrand = (params) => $http.get('/org/Category/getEqBrand',{
    params
})
// 获取设备型号
const deviceModel = (params) => $http.get('/org/Category/getEqModel', {
    params
})


// 添加用户-获取设备编号
const deviceCode= (params) => $http.get('/org/Eq/getRealCode', {
    params
})



export default {
    getDeviceType,
    getDeviceList,
    addDevice,
    deviceBindUsers,
    userBindDevice,
    userUnbindDevice,
    deviceBindLog,
    deviceBrand,
    deviceType,
    deviceModel,
    deviceCode
}
